import { LocationGeoType, REGION_ID } from '@tt4b/ttam-enums';
import { i18n } from '@tt4b/ttam-i18n';
import { LocationTypeValue, UploadLocationsItem, CurrentLocationStatus, LocationTypeListInterface } from './types';
import { genInputId, resetInputId } from './utils';

export const MAX_COUNT = 1500; // 批量上传最大个数限制
export const REDEX_PASTE_SEPARATE_SYMBOL = /[;]/;
export const genDefaultLocationItem = (type?: 'reset'): UploadLocationsItem => {
  if (type === 'reset') {
    resetInputId();
  }
  const inputId = genInputId();
  return {
    value: '',
    status: CurrentLocationStatus.UN_KNOW,
    readonly: false,
    suffixIcon: 'vi-icon-ex-loading1',
    inputId,
    isError: false,
    matchList: [],
    isMatchPanelVisible: false,
    checked: false,
    domId: `viInput-${inputId}`,
  };
};

export const genLocationTypeList: () => LocationTypeListInterface[] = () => [
  {
    label: i18n.t('adgroup_location_bulk_upload_type_postal_code'),
    value: LocationTypeValue.ZIP_CODE,
  },
  {
    label: i18n.t('adgroup_location_bulk_upload_type_city'),
    value: LocationTypeValue.CITY,
  },
];

export const LocationType: { [k in LocationTypeValue]: LocationGeoType[] } = {
  [LocationTypeValue.CITY]: [
    LocationGeoType.COUNTRY,
    LocationGeoType.CITY,
    LocationGeoType.PROVINCE,
    LocationGeoType.DISTRICT,
    LocationGeoType.DMA,
  ],
  [LocationTypeValue.ZIP_CODE]: [LocationGeoType.ZIP_CODE],
};

export const genBulkUploadSupportCountry = (options: { isCASupportZipcode: boolean }) => {
  const { isCASupportZipcode } = options;
  const list = [REGION_ID.UNITED_STATES];
  if (isCASupportZipcode) {
    list.push(REGION_ID.CANADA);
  }

  return list;
};

export const UploadFileSupportConfig = {
  locationType: [LocationTypeValue.ZIP_CODE],
};

// undo 展示的location个数
export const DISPLAY_NUMBER = 2;
